var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tag',{attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.showText))])
}
var staticRenderFns = []

export { render, staticRenderFns }